import { DropdownAction } from "../../../../../components/Dropdown/types";
import { ProgressRow, ProgressRowActions } from "./types";

export const rowActionsOf = (
  row: ProgressRow,
  {
    onView,
    onEdit,
    onDuplicate,
    onDelete,
    onDeleteCorrection,
  }: ProgressRowActions,
): DropdownAction[] => {
  const view: DropdownAction = {
    id: "view",
    label: "View details",
    icon: "",
    onClick: () => onView(row),
    show: true,
  };
  const { transaction, correction } = row;
  if (correction !== null) {
    return [
      view,
      {
        id: "delete",
        label: "Delete correction",
        icon: "",
        onClick: () => onDeleteCorrection(correction),
        variant: "destructive",
        show: true,
      },
    ];
  }
  if (!row.isEditable || transaction === null) {
    return [view];
  }
  return [
    view,
    {
      id: "edit",
      label: "Edit progress",
      icon: "",
      onClick: () => onEdit(transaction),
      show: true,
    },
    {
      id: "duplicate",
      label: "Duplicate progress",
      icon: "",
      onClick: () => onDuplicate(transaction),
      show: true,
    },
    {
      id: "delete",
      label: "Delete progress",
      icon: "",
      onClick: () => onDelete(transaction),
      variant: "destructive",
      show: true,
    },
  ];
};
